module.exports = __webpack_public_path__ + "static/img/sbjc.ae097e88.png";